import { render, staticRenderFns } from "./WahooBay.vue?vue&type=template&id=03aeaba5"
import script from "./WahooBay.vue?vue&type=script&lang=js"
export * from "./WahooBay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports